import React, { useState, useEffect } from 'react';
import { Box, Typography, Tabs, Tab, styled, } from '@mui/material';
import {
    FlagOutlined,
    AssignmentTurnedIn,
    LeaderboardOutlined,
} from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import GoalManagement from './goalManagement/goalManagement';

const StyledTabs = styled(Tabs)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    marginBottom: theme.spacing(3),
    padding: '4px', // Reduced padding
    minHeight: 48, // Ensure consistent height
    '& .MuiTabs-indicator': {
        height: 0,
    },
    '& .MuiTabs-flexContainer': {
        // This ensures tabs don't squash if the container gets too small
        gap: '4px',
    },
    '& .MuiTab-root': {
        fontWeight: 600,
        color: theme.palette.text.secondary,
        textTransform: 'none',
        minHeight: 44, // Slightly smaller
        minWidth: 'auto', // Allow tabs to shrink to their text size
        borderRadius: 8,
        margin: 0, // Reset margin to use Gap instead
        padding: '6px 16px', // Standardized padding
        flexDirection: 'row', // Keeps icon and text on one line to save vertical space
        gap: '8px',
        '&.Mui-selected': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.light + '20',
        },
        // Ensure icons don't cause alignment issues
        '& .MuiSvgIcon-root': {
            marginBottom: '0 !important',
            fontSize: '1.2rem',
        },
    },
}));

function HRPerformanceDashboard() {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.activeTab ?? 0);

    useEffect(() => {
        if (location.state?.activeTab !== undefined) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <Typography variant="h5" fontWeight="700" color="#1e293b" gutterBottom>
                Performance Management
            </Typography>

            <Box>
                <StyledTabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab icon={<FlagOutlined />} label="Employee Goals" />
                    <Tab icon={<AssignmentTurnedIn />} label=" Employee Appraisals" />
                    <Tab icon={<LeaderboardOutlined />} label="Employee Performance Bands" />
                </StyledTabs>
                <Box>
                    {activeTab === 0 && <GoalManagement />}

                </Box>
            </Box>
        </>
    );
}

export default HRPerformanceDashboard;